
import React from 'react';
import { motion } from 'framer-motion';
import { Star, TrendingUp, Award, Clock } from 'lucide-react';

export function ProductBadges({ product, compact = false }) {
  const badges = [];

  // Amazon's Choice simulation
  if (product.rating >= 4.5 && product.review_count > 1000) {
    badges.push({
      type: 'choice',
      text: "Amazon's Choice",
      icon: Award,
      className: 'bg-orange-100 text-orange-800 border-orange-200'
    });
  }

  // Best Seller simulation
  if (product.rating >= 4.7 && product.review_count > 5000) {
    badges.push({
      type: 'bestseller',
      text: '#1 Best Seller',
      icon: Star,
      className: 'bg-yellow-100 text-yellow-800 border-yellow-200'
    });
  }

  // Hot Deal
  if (product.discount > 25) {
    badges.push({
      type: 'hotdeal',
      text: '🔥 Hot Deal',
      icon: TrendingUp,
      className: 'bg-red-100 text-red-800 border-red-200'
    });
  }

  // Recently Updated
  const updatedRecently = product.updated_at && 
    new Date() - new Date(product.updated_at) < 2 * 60 * 60 * 1000; // 2 hours
  
  if (updatedRecently) {
    badges.push({
      type: 'updated',
      text: 'Just Updated',
      icon: Clock,
      className: 'bg-green-100 text-green-800 border-green-200'
    });
  }

  if (badges.length === 0) return null;

  return (
    <div className={`flex flex-wrap gap-1 ${compact ? 'gap-1' : 'gap-2'}`}>
      {badges.slice(0, compact ? 2 : 3).map((badge, index) => (
        <motion.div
          key={badge.type}
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: index * 0.1 }}
          className={`
            inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium border
            ${badge.className} ${compact ? 'text-xs' : 'text-xs sm:text-sm'}
          `}
          data-analytics-id={`badge-${badge.type}`}
        >
          {badge.icon && (
            <badge.icon size={compact ? 10 : 12} className="flex-shrink-0" />
          )}
          <span className={compact ? 'hidden sm:inline' : ''}>{badge.text}</span>
        </motion.div>
      ))}
    </div>
  );
}
